import { render, staticRenderFns } from "./ExpansionPanelField.vue?vue&type=template&id=6ed4445a&scoped=true"
import script from "./ExpansionPanelField.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelField.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanelField.vue?vue&type=style&index=0&id=6ed4445a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4445a",
  null
  
)

export default component.exports